import Tippy from '@tippyjs/react';
import React from 'react';

import { ControlledModal, InlineIconButton } from '@/components';
import { EditIcon } from '@/components/icons';
import { PlayerGeoLocationStatusForm } from '@/forms';

export const GeoLocationStatus = ({
  playerId,
  status,
}: {
  playerId: string;
  status: string;
}) => {

  return (
    <>
      {status}
      <ControlledModal
        content={
          <PlayerGeoLocationStatusForm playerId={playerId} status={status} />
        }
      >
        <InlineIconButton>
          <Tippy content={'Edit'}>
            <div>
              <EditIcon />
            </div>
          </Tippy>
        </InlineIconButton>
      </ControlledModal>
    </>
  );
};
